export const MANUFACTURERS = {
  cypres: {
    models: {
      'c-mode-2':   { new_price_eur: 1330 },
      'expert-2':   { new_price_eur: 1330 },
      'speed-2':    { new_price_eur: 1330 },
      'student-2':  { new_price_eur: 1330 },
      'tandem-2':   { new_price_eur: 1430 },
      'wingsuit-2': { new_price_eur: 1780 },
    },
    service_life: [
      { dom_up_to: 2015, years: 12.5 },
      { dom_up_to: 2016, years: 12.5 },
      { dom_from: 2017, years: 15.5 },
    ],
    trade_in_value_eur: 65,
  },

  vigil: {
    models: {
      'cuatro':       { new_price_eur: 1122 },
      'cuatro-2-pin': { new_price_eur: 1218 },
      '2-plus':       { new_price_eur: 1122 },
      '2':            { new_price_eur: 1122 },
    },
    service_life_years: 20,
    battery: {
      life_years_dom_up_to_2018: 10,
      life_years_dom_from_2019: 12,
      replacement_cost_eur: 282,
    },
    floor_value_eur: 0,
  },

  mars: {
    models: {
      'm2-multi': { new_price_eur: 956 },
    },
    service_life_years: 15.5,
    floor_value_eur: 0,
  },
};
